import pipe from './pipe';
import sanitize from './sanitize';

export default pipe(sanitize, (params) =>
  new URLSearchParams(params).toString()
);
